import React from 'react';

import * as S from './styles';

export const Label: React.FC = ({ children, ...rest }) => {
  return <S.Container {...rest}>{children}</S.Container>;
};
